<template>
    <form @submit.prevent="submit" ref="form">
        <text-input v-model="form.title" :errors="$page.props.errors.title" class="mb-3" label="Titel" />

        <text-input v-model="form.slug" :errors="$page.props.errors.slug" class="mb-3" label="Slug" />

        <wysiwyg  :value="form.body" v-model="form.body" :error="$page.props.errors.body" label="Omschrijving" :insert-media="true" imageable-type="sitepage"></wysiwyg>

        <button type="submit" class="mt-5 text-white bg-teal-700 px-5 py-3 rounded inline-block hover:bg-teal-800 focus:bg-teal-800">
            <i class="fal mr-1" :class="loading == 'submit' ? 'fa-spinner fa-spin' : 'fa-save'"></i>Opslaan
        </button>
    </form>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import TextInput from "@/admin/Shared/TextInput";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import wysiwyg from "@/admin/Shared/WYSIWYG";

export default {
    components: {
        TextInput,
        wysiwyg
    },

    mixins: [Helpers],

    props: {
        dataLoading: false,
        sitepage: {
            type: Object,
            default() {
                return {};
            }
        },
    },

    watch: {
        dataLoading: function(loading) {
            this.loading = loading;
        }
    },

    // remember: "form",

    data() {
        return {
            form: {
                title: this.sitepage.title || "",
                slug: this.sitepage.slug || "",
                body: this.sitepage.body || "",
            }
        };
    },

    methods: {
        submit() {
            var data = new FormData();

            data.append("title", this.form.title);
            data.append("slug", this.form.slug);
            data.append("body", this.form.body || "");

            this.$emit("submit", data);
        }
    }
};
</script>
